import React from "react";

const TextPanel = ({ children, onTrackPointerDown, onThumbPointerDown, thumbTop, thumbH, hasOverflow, trackRef, thumbRef }) => (
  <div className="flex gap-[10.18px] flex-1 min-h-0 mx-auto w-full">
    <div className="bg-white rounded-[27px] p-3 flex flex-col flex-1 h-full overflow-hidden">
      {children}
    </div>
    <div
      ref={trackRef}
      className="relative w-[14px] lg:w-[17.94px] h-full bg-[#C7BFE4] rounded-[17px] flex-shrink-0 cursor-pointer"
      style={{ visibility: hasOverflow ? "visible" : "hidden" }}
      onPointerDown={onTrackPointerDown}
    >
      {hasOverflow && (
        <div
          ref={thumbRef}
          className="absolute w-full bg-[#3D2B90] rounded-[10px] cursor-grab active:cursor-grabbing"
          style={{ top: `${thumbTop}px`, height: `${thumbH}px` }}
          onPointerDown={onThumbPointerDown}
        />
      )}
    </div>
  </div>
);

export default TextPanel;
